import React from 'react';
import Hero from './components/online-payment/Hero';
import Main from './components/online-payment/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';


const OnlinePayment = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default OnlinePayment;